import { useEffect, useState } from "react";
import axiosClient from "../../api/axios";
import { useNotification } from "../../components/notification/NotificationContainer";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthRedirect from "../../components/hoc/AuthRedirect";
import { useDispatch } from "react-redux";
import InputField from "../../components/form/InputField";
import { useForm } from "react-hook-form";
import { newPasswordToken } from "../../features/userSlice";
import Loading from "../../components/loading/Loading";
import { resetPasswordSchema } from "../../schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import loadStatus from "../../util/loadStatus";

const NewPassword = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addNotification = useNotification();
  const [errorStyle, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(resetPasswordSchema),
  });
  const getState = async () => {
    try {
      setLoading(true);
      const res = await axiosClient.get("/new-password/" + token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        setError(error.response.data);
      } else {
        addNotification(error.message, "warning");
      }
    }
  };

  useEffect(() => {
    getState();
  }, []);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const res = await dispatch(newPasswordToken({ id: token, data }));
      setLoading(false);
      if (newPasswordToken.fulfilled.match(res)) {
        addNotification("Password changed successfully", "success");
        navigate("/login");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      setLoading(false);
      addNotification(error.message, "warning");
    }
  };
  if (loading) {
    <Loading />;
  }

  return (
    <AuthRedirect>
      <div className="auth-container">
        <div className="auth-content ">
          <div className=" auth-inner-content ">
            <h2 className="auth-title">New Password</h2>
            {errorStyle?.code === 404 ? (
              <div className="p-5 flex flex-col justify-center items-center gap-5">
                Token Not Found,
                <Link to="/" className="add-rss-btn">
                  Go to Home
                </Link>
              </div>
            ) : errorStyle?.code === 410 ? (
              <div className="p-5 flex flex-col justify-center items-center gap-5">
                Reset Token is expired,
                <Link to="/" className="add-rss-btn">
                  Go to Home
                </Link>
              </div>
            ) : (
              <>
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="flex flex-col gap-y-3 pb-5"
                >
                  <InputField
                    register={register}
                    name="password"
                    type="password"
                    label="Password"
                    errors={errors.password}
                  />
                  <InputField
                    register={register}
                    name="confirm_password"
                    type="password"
                    label="ConfirmPassword"
                    errors={errors.confirm_password}
                  />
                  <button
                    disabled={loading}
                    className="auth-btn inline-block py-4"
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
                <p className="text-xs text-center">
                  Already have an account?{" "}
                  <Link
                    to="/login"
                    className="text-indigo-600 underline hover:text-indigo-800"
                  >
                    Sign In
                  </Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </AuthRedirect>
  );
};

export default NewPassword;
